module.exports = __webpack_public_path__ + "img/record_voice_over.ff2b4cd7.svg";